import axios from 'axios'
import { ServiceRouter } from '../../../../../base/proxy/serviceRouter'
import { getToken, getUserId } from '../../../../../base/proxy/helper'

export interface IVideoLargePayload {
  Id: number
  VideoCategoryId: number
  Title: string
  Description: string
  SourceType: number
  ExternalUrl: string
  OrderNo: number
  Active: boolean
  DealerCodes: string[]
  DealerTypes: string[]
  DealerSubTypes: string[]
  DealerCodesInclude: boolean
  DealerTypesInclude: boolean
  DealerSubTypesInclude: boolean
  file?: File | null
  thumbnail?: File | null
}

// Uploads video/SCORM as multipart/form-data (streamed) instead of base64 JSON, so large files work.
export class PostVideoLargeApi {
  public async save(payload: IVideoLargePayload): Promise<any> {
    const form = new FormData()
    form.append('Id', String(payload.Id ?? 0))
    form.append('VideoCategoryId', String(payload.VideoCategoryId))
    form.append('Title', payload.Title ?? '')
    form.append('Description', payload.Description ?? '')
    form.append('SourceType', String(payload.SourceType))
    form.append('ExternalUrl', payload.ExternalUrl ?? '')
    form.append('OrderNo', String(payload.OrderNo ?? 0))
    form.append('Active', payload.Active ? 'true' : 'false')
    form.append('DealerCodes', JSON.stringify(payload.DealerCodes ?? []))
    form.append('DealerTypes', JSON.stringify(payload.DealerTypes ?? []))
    form.append('DealerSubTypes', JSON.stringify(payload.DealerSubTypes ?? []))
    form.append('DealerCodesInclude', payload.DealerCodesInclude ? 'true' : 'false')
    form.append('DealerTypesInclude', payload.DealerTypesInclude ? 'true' : 'false')
    form.append('DealerSubTypesInclude', payload.DealerSubTypesInclude ? 'true' : 'false')
    if (payload.file) form.append('file', payload.file)
    if (payload.thumbnail) form.append('thumbnail', payload.thumbnail)

    const url = `${ServiceRouter.getServiceUrl()}admin/video/save-large`

    const response = await axios.post(url, form, {
      timeout: 30 * 60 * 1000,
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
      headers: {
        Authorization: `Bearer ${getToken()}`,
        UserId: String(getUserId()),
        // Content-Type intentionally omitted so axios sets the multipart boundary
      },
    })

    const data = response.data
    if (data && data.Data === null && data.Message && data.Message !== 'OK') {
      throw { code: data.Message, description: data.Message, success: data.Success }
    }
    return data?.Data
  }
}
